import React from 'react';
import type { ElementInterpolator as Props } from './element-interpolator.types';

type Element = Props['elements'][string];
type Child = string | Element;

// NOTE: Returns a list of strings and React elements
const replaceToken = (string: string, tokenName: string, element: Element) =>
  string
    .split(`$${tokenName}$`)
    .reduce<Child[]>(
      (accum, text, index) =>
        index === 0 ? [text] : [...accum, element, text],
      []
    );

const ElementInterpolator: React.FunctionComponent<Props> = ({
  elements,
  template,
}) => {
  if (!template) {
    return null;
  }

  const interpolatedElements = Object.entries(elements)
    .reduce<Child[]>(
      (accum, [tokenName, element]) =>
        accum.flatMap(item =>
          typeof item === 'string'
            ? replaceToken(item, tokenName, element)
            : item
        ),
      [template]
    )
    .map(child =>
      // NOTE: Remove any remaining tokens because in some places the data is not ready until after mount, in which case the raw tokens (like '$name$') would be visible for a second.
      typeof child === 'string' ? (
        <React.Fragment key={child}>
          {child.replace(/\$[a-zA-Z]+\$/g, '')}
        </React.Fragment>
      ) : (
        <React.Fragment key={child?.key}>{child}</React.Fragment>
      )
    );

  return <>{interpolatedElements}</>;
};

export default ElementInterpolator;
